import request from "superagent";
import { getAuthHeader } from "../../../utils/superagent";
import { environmentConfig } from "@src/appV2/environment";
const paymentServiceApi = environmentConfig.REACT_APP_PAYMENTS_API_URL;

export const fetchAgentPaymentsBalanceInfo = async ({ userId }: { userId: string }) => {
  const { body } = await request
    .get(`${paymentServiceApi}/accounts/balance/${userId}`)
    .set(await getAuthHeader());
  return body;
};

export const payoutById = async ({ userId }: { userId: string }) => {
  const { body } = await request
    .post(`${paymentServiceApi}/accounts/${userId}/payout`)
    .set(await getAuthHeader());
  return body;
};
